<template>
  <div class="table-monitoria">
    <table class="produto-monitorados">
      <tr>
        <th @click="toggleTodos(produtosPaginados)" class="centralizado click-expandir">
          <font-awesome-icon v-if="opened.length > 0" icon="minus" />
          <font-awesome-icon v-else icon="plus" />
        </th>
        <th
          @click="ordenar('data_alteracao')"
          :class="[
            'centralizado ',
            'pointer',
            { 'ordem-crescente': strOrdem == 'data_alteracao' && !reverse },
            { 'ordem-decrescente': strOrdem == 'data_alteracao' && reverse }
          ]"
        >
          ULT. ALTERAÇÃO
        </th>
        <th
          @click="ordenar('ncm')"
          :class="[
            'centralizado',
            'pointer',
            { 'ordem-crescente': strOrdem == 'ncm' && !reverse },
            { 'ordem-decrescente': strOrdem == 'ncm' && reverse }
          ]"
        >
          NCM
        </th>
        <th class="centralizado">
          EX
        </th>
        <th class="centralizado">
          CEST
        </th>
        <th
          @click="ordenar('nome')"
          :class="[
            'centralizado',
            'pointer',
            { 'ordem-crescente': strOrdem == 'nome' && !reverse },
            { 'ordem-decrescente': strOrdem == 'nome' && reverse }
          ]"
        >
          PRODUTO
        </th>
        <th class="centralizado">ICMS</th>
        <th class="centralizado">PIS/COFINS</th>
        <th class="centralizado">IPI</th>
        <th class="centralizado" v-b-tooltip.hover.window title="IMPOSTO DE IMPORTAÇÃO">
          II
        </th>
        <th class="centralizado" v-b-tooltip.hover.window title="IMPOSTO DE IMPORTAÇÃO">
          IE
        </th>
        <th class="centralizado" v-b-tooltip.hover.window title="CIDE-COMBUSTÍVEIS">
          CIDE
        </th>
        <th class="centralizado" v-b-tooltip.hover.window title="DEFESA COMERCIAL">
          DEF.
        </th>
        <th class="centralizado" v-b-tooltip.hover.window title="ACORDOS INTERNACIONAIS">
          Acordos
        </th>
        <th class="centralizado" colspan="3">
          <font-awesome-icon
            icon="bolt"
            data-toggle="tooltip"
            data-placement="top"
            data-original-title="Ações"
          />
        </th>
      </tr>
      <tbody
        v-if="produtosPaginados"
        v-for="(grupoProduto, index) in produtosPaginados
          ? Object.fromEntries(produtosPaginados)
          : {}"
        :key="index"
      >
        <tr
          @click="toggle(grupoProduto)"
          :class="[
            'click-expandir',
            { 'grupo-monitoria': grupoProduto.length > 1 },
            { 'grupo-monitoria-opened': !!opened.includes(grupoProduto[0].id) }
          ]"
        >
          <td>
            <font-awesome-icon
              v-if="grupoProduto.length > 1 && !opened.includes(grupoProduto[0].id)"
              icon="plus"
              data-toggle="tooltip"
              data-placement="top"
              data-original-title="Ações"
            />
            <font-awesome-icon
              v-if="grupoProduto.length > 1 && opened.includes(grupoProduto[0].id)"
              icon="minus"
              data-toggle="tooltip"
              data-placement="top"
              data-original-title="Ações"
            />
          </td>

          <td class="centralizado">
            <span>{{
              grupoProduto[0].data_alteracao != "-"
                ? formatDate(grupoProduto[0].data_alteracao)
                : grupoProduto[0].data_alteracao
            }}</span>
          </td>
          <td class="centralizado">
            <span>{{ grupoProduto[0].ncm }}</span>
          </td>
          <td class="centralizado">
            {{ grupoProduto[0].ex == 0 ? "-" : grupoProduto[0].ex }}
          </td>
          <td class="centralizado">
            <span>{{ grupoProduto[0].cest == 0 ? "-" : grupoProduto[0].cest }}</span>
          </td>
          <td>
            <span class="centralizado">{{
              grupoProduto.length > 1
                ? `${grupoProduto.length} PRODUTOS AGRUPADOS`
                : grupoProduto[0].nome
            }}</span>
          </td>

          <!-- SINOS -->
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
            />
            <SinosMonitoramento v-else :tipo="'single'" :produto="grupoProduto[0]" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'2'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'2'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'4'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'4'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'5'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'5'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'6'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'6'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'3'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'3'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'7'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'7'"
            />
          </td>
          <td class="centralizado">
            <SinosMonitoramento
              v-if="grupoProduto.length > 1"
              :tipo="'grouped'"
              :produto="grupoProduto"
              :id_monitoria="'12'"
            />
            <SinosMonitoramento
              v-else
              :tipo="'single'"
              :produto="grupoProduto[0]"
              :id_monitoria="'12'"
            />
          </td>
          <td class="centralizado">
            <div v-if="grupoProduto.length <= 1" @click="abrirHistorico(grupoProduto[0])">
              <span
                v-if="!acesso_simulado"
                class="bt-editar-empresa-modal"
                v-b-tooltip.hover.window
                title="Visualizar alterações"
              >
                <font-awesome-icon class="ver-mais" icon="history" />
              </span>
              <span v-else class="text-muted">
                <font-awesome-icon icon="history" />
              </span>
            </div>
          </td>

          <td class="centralizado">
            <div v-if="grupoProduto.length <= 1" class="flex-1 text-center bell">
              <span
                v-if="(!acesso_simulado || grupoProduto.length < 1) && !blBigData"
                v-b-tooltip.hover.window
                @click="editarProdutoMonitoria(grupoProduto[0])"
                title="Editar Produto"
              >
                <font-awesome-icon class="ver-mais c-pointer" icon="edit"
              /></span>
              <span v-else> <font-awesome-icon class="desabilita" icon="edit"/></span>
            </div>
          </td>

          <td class="centralizado">
            <div v-if="grupoProduto.length <= 1">
              <span
                v-if="!acesso_simulado && !blBigData"
                v-b-tooltip.hover.window
                @click="deletaProduto(grupoProduto[0])"
                title="Remover Produto"
              >
                <font-awesome-icon class="ver-mais apagar" icon="times"
              /></span>
              <span v-else class="desabilita"> <font-awesome-icon icon="times"/></span>
            </div>
          </td>
        </tr>

        <!-- Linha com itens agrupados -->
        <tr
          v-if="opened.includes(grupoProduto[0].id)"
          v-for="(produto, index) in grupoProduto"
          :key="index"
          class="monitoria-row-opened"
        >
          <td></td>

          <td class="centralizado">
            <span>{{
              produto.data_alteracao != "-"
                ? formatDate(produto.data_alteracao)
                : produto.data_alteracao
            }}</span>
          </td>
          <td class="centralizado">
            <span>{{ produto.ncm }}</span>
          </td>
          <td class="centralizado">{{ produto.ex == 0 ? "-" : produto.ex }}</td>
          <td class="centralizado">
            <span>{{ produto.cest == 0 ? "-" : produto.cest }}</span>
          </td>
          <td>
            <span class="centralizado">{{ produto.nome }}</span>
          </td>

          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'2'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'4'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'5'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'6'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'3'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'7'" />
          </td>
          <td class="centralizado">
            <SinosMonitoramento :tipo="'single'" :produto="produto" :id_monitoria="'12'" />
          </td>

          <td class="centralizado" @click="abrirHistorico(produto)">
            <span
              v-if="!acesso_simulado"
              class="bt-editar-empresa-modal"
              v-b-tooltip.hover.window
              title="Visualizar alterações"
            >
              <font-awesome-icon class="ver-mais" icon="history" />
            </span>
            <span v-else class="text-muted">
              <font-awesome-icon icon="history" />
            </span>
          </td>

          <td class="centralizado">
            <div class="flex-1 text-center bell">
              <span
                v-if="!acesso_simulado || !blBigData"
                v-b-tooltip.hover.window
                @click="editarProdutoMonitoria(produto)"
                title="Editar Produto"
              >
                <font-awesome-icon class="ver-mais c-pointer" icon="edit"
              /></span>
              <span v-else class="text-muted"> <font-awesome-icon icon="edit"/></span>
            </div>
          </td>

          <td class="centralizado">
            <span
              v-if="!acesso_simulado && !blBigData"
              v-b-tooltip.hover.window
              @click="deletaProduto(produto)"
              title="Remover Produto"
            >
              <font-awesome-icon class="ver-mais apagar" icon="times"/></span
            ><span v-else class="desabilita"> <font-awesome-icon icon="times"/></span>
          </td>
        </tr>

        <!-- Linha com itens agrupados -->
      </tbody>
    </table>
    <ModalExcluirMonitoria :dadosProdutoDelete="produtoDelete" @atualiza="emitListarProdutos" />
  </div>
</template>

<script>
import SinosMonitoramento from "@/components/Sinos/SinosMonitoramento.vue";
import ModalProduto from "@/components/ModalProduto/ModalProduto.vue";
import { mapGetters } from "vuex";
import ModalExcluirMonitoria from "./ModalExcluirMonitoria.vue";
import dateFormatMixin from "@/mixins/dateFormatMixin";
import Api from "@/services/api.js";

export default {
  name: "TabelaProdutoMonitoria",
  inject: ["pushAlert"],
  mixins: [dateFormatMixin],

  props: {
    produtosPaginados: {
      type: [Object, Array], // Aceita tanto objeto como array
      required: true
    }
  },
  components: {
    SinosMonitoramento,
    ModalProduto,
    ModalExcluirMonitoria
  },
  data() {
    return {
      strOrdem: "",
      opened: [],
      acesso_simulado: localStorage.getItem("token_simulacao") ? true : false,
      tituloModalProduto: "",
      editarProdutoData: null,
      atualizaModal: false,
      reverse: false,
      produtoDelete: null,
      produtoCadastrados: []
    };
  },
  mouted() {
    this.listarProdutosCadastrados();
  },
  computed:{
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    ...mapGetters("loading", {
      blBigData: "getBlBigData"
    })
  },
  methods: {
    deletaProduto(produto) {
      if (this.blUsuarioPro) {
        this.pushAlert("Opção desabilitada na versão de testes", "danger");
        return;
      }
      this.produtoDelete = produto;
      this.$root.$emit("bv::show::modal", "ModalExcluirMonitoria");
    },
    toggleTodos(produto) {
      if (this.opened.length == 0) {
        produto.map(p => p[1]).forEach(e => this.toggle(e));
      } else {
        this.opened = [];
      }
    },
    abrirHistorico: function(item) {
      var name = "monitoria/" + item.id;
      this.$router.push(name);
    },
    toggle(id) {
      // console.log(id);
      if (id.length <= 1) return;
      const index = this.opened.indexOf(id[0].id);
      if (index > -1) {
        this.opened.splice(index, 1); // fecha
      } else {
        this.opened.push(id[0].id); // abre
      }
    },
    emitListarProdutos() {
      this.$emit("atualizaProdutos");
    },
    ordenar(strOrdem) {
      this.strOrdem = strOrdem;
      this.$emit("ordenar", strOrdem);
      if (strOrdem == this.strOrdem) {
        this.reverse = !this.reverse;
        return;
      }
      this.reverse = false;
    },
    listarProdutosCadastrados() {
      if (
        !this.getEmpresa ||
        Object.keys(this.getEmpresa).length == 0 ||
        (this.getEmpresa && !this.getEmpresa.id)
      ) {
        this.produtoCadastrados = [];
        return;
      }
      new Api().get("Produto/obterProdutosEmpresa/" + this.getEmpresa.id).then(response => {
        if (!response) {
          this.produtoCadastrados = [];
          return;
        }
        if (response.dados) {
          this.produtoCadastrados = response.dados.filter(f => f.vigente == 1 && f.ncm.length >= 8);
        } else {
          this.produtoCadastrados = [];
        }
      });
    },

    editarProdutoMonitoria(prod) {
      this.$emit("editarProduto", prod);
    }
  }
};
</script>

<style lang="scss" scoped>
.sinos-legenda {
  margin-top: 10px;
}
.pointer {
  cursor: pointer;
  user-select: none;
}
.table-monitoria table tr {
  background-color: #fff;
}

.table-monitoria table tr:nth-child(even) td,
.monitoria-row-opened {
  background: #eaf0f7 !important;
  position: relative;
}
.table-monitoria {
  td {
    border: 1px solid rgba(0, 0, 0, 0.096);
    border-bottom: none;
    max-width: 257px;
    overflow-x: hidden;
  }
}
.produto-monitorados {
  tbody:last-child {
    td {
      border-bottom: 1px solid rgba(0, 0, 0, 0.096);
    }
  }
}

.desabilita {
  color: #51585c;
  cursor: default;
}
.table-monitoria .grupo-monitoria {
  td {
    border-top: 1px solid rgba(0, 0, 0, 0.651) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.651) !important;
  }
}

.monitoria-row-opened:last-child td {
  border-bottom: 1px solid rgb(75, 73, 73) !important;
}

.table-monitoria .grupo-monitoria-opened {
  td {
    border-bottom: none !important;
  }
}

.ordem-crescente {
  background: linear-gradient(#08486c, #5587a0);
}
.ordem-decrescente {
  background: linear-gradient(#5587a0, #08486c);
}
.click-expandir {
  cursor: pointer;
  user-select: none;
}
</style>
